var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHkexpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 768.88 280.28",
    style: {
      enableBackground: "new 0 0 768.88 280.28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#702B91;}\r\n\t.st1{fill:#21B9DA;}\r\n\t.st2{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "307.82,102.12 279.26,102.12 279.26,79.16 271.16,79.16 271.16,132.58 279.26,132.58 279.26,109.21  307.82,109.21 307.82,132.58 315.92,132.58 315.92,79.16 307.82,79.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "346.84,102.51 334.69,102.51 334.69,79.16 326.59,79.16 326.59,132.58 334.69,132.58 334.69,109.6  346.42,109.59 362.65,132.64 371.2,132.64 371.2,131.37 353.06,106.24 371.23,80.4 371.23,79.16 362.81,79.16  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M648.69,88.95c5.08,0,11.5,1.62,16.6,4.17l3.51-11.51c-4.07-1.84-12.15-3.72-18.86-3.72 c-14.07,0-23.22,6.87-23.32,17.51c-0.08,8.06,4.04,13.09,12.59,15.39l9.32,2.45c3.84,1,7.29,2.13,7.26,5.04 c-0.04,4.38-4.81,4.94-8.95,4.94c-6.71,0-13.28-2.81-17.04-4.76l-2.48,11.25c3.05,1.52,10.24,4.47,20.02,4.47 c13.28,0,21.26-6.35,21.36-16.97c0.08-8.18-3.74-12.83-12.38-15.07l-10.25-2.66c-3.96-1.05-6.36-1.93-6.33-5.25 C639.77,90.86,643.03,88.95,648.69,88.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M703.9,102.12l-10.25-2.66c-3.96-1.05-6.36-1.93-6.33-5.25c0.03-3.34,3.3-5.26,8.96-5.26 c5.08,0,11.5,1.62,16.6,4.17l3.51-11.51c-4.07-1.84-12.15-3.72-18.86-3.72c-14.07,0-23.22,6.87-23.32,17.51 c-0.08,8.06,4.04,13.09,12.59,15.39l9.32,2.45c3.84,1,7.29,2.13,7.26,5.04c-0.04,4.38-4.81,4.94-8.95,4.94 c-6.71,0-13.28-2.81-17.04-4.76l-2.48,11.25c3.05,1.52,10.24,4.47,20.02,4.47c13.28,0,21.26-6.35,21.36-16.97 C716.37,109.01,712.55,104.36,703.9,102.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M501.51,77.88c-12.53-0.83-22.24,7.27-22.24,7.27l-0.01,68.74H493V91.31c2.24-0.79,4.56-1.28,6.72-1.28 c10.87,0,15.35,8.68,15.35,16.89c0,10.15-8.96,15.7-17.3,13.9l-0.02,13.17c28.2,1.8,31.52-21.37,31.55-28.17 C529.6,90.53,519.22,78.54,501.51,77.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M542.7,83.08c-5.15,2.94-5.51,6.8-5.53,8.81l0.01,40.55h13.81l-0.01-38.77c0,0,7.12-4.95,19.18-3.64 l0.11-10.77c-1.77-0.77-4.16-1.1-7.17-1.15C552.84,77.93,545.1,81.61,542.7,83.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M589.62,118.85c-2.73-2.16-4.39-5.32-4.59-8.8c-0.41-6.85,4.35-12.82,5.31-14.03 c4.9-5.39,10.28-6.2,13.69-5.16c4.59,1.41,2.33,4.53,0.28,6.54c-4.72,4.64-12.04,4.57-12.04,4.57 c-2.98,4.92-3.71,9.32-0.31,12.36c6.76,1.12,15.17-1.04,21.79-7.08c7.19-6.65,6.33-13.44,5.18-16.9 c-1.8-5.4-6.55-9.74-12.7-11.62c-3.44-1.25-16.13-2.8-26.08,8.23c-9.18,10.9-10.66,25.58-3,36.04 c12.95,17.76,34.91,10.49,42.86,5.12L612.26,117C607.45,120.55,596.68,124.43,589.62,118.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M473.13,79.55l0.12-0.33h-14.57l-0.07,0.14c-2.52,5.12-6.12,10.62-10.41,15.92l-11.21-16.06h-15.23 l17.9,25.64c-4.78,4.24-18.52,14.91-30.36,16.96c-8.82,1.53-15.85-1.66-19.89-6.78c-1.52-1.93-2.47-4.28-2.49-6.74 c-0.05-6.29,4.46-12.03,5.31-13.09c2.96-3.25,6.09-4.84,8.85-5.36c1.82-0.34,3.48-0.24,4.81,0.21c1.7,0.57,5.22,1.82,0.1,6.72 c-4.85,3.82-8.37,4.02-11.97,4.38c-5.01,8.02-1.08,11.99,1.28,12.47c8.66,0.94,16.24-3.42,20.32-7.2 c3.09-2.86,7.86-8.85,5.18-16.9c-1.8-5.4-6.55-9.74-12.7-11.62c-3.44-1.05-15.49-3.56-26.08,8.23c0,0-11.48,12.36-6.75,28.04 c5.19,17.18,20.73,21.26,35.36,20.02c14.69-1.25,27.8-10.92,36.61-18.48l11.39,16.99h15.23l-17.58-25.86 C464.11,97.82,470.08,88.13,473.13,79.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "292.54,171.81 270.06,143.73 249.49,160.93 271.97,189.01  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.96,166.16c0,0-27.47,25.53-55.68,25.53c-33.32,0-42.77-23.72-44.4-28.48 c-9.59-27.92,15.73-60.78,32.57-69.68c6.87-3.64,16.58-7.29,23.93-3.38c0.25,0.13,3.16,1.86-1.42,10.12 c-2.94,5.29-17.94,25.44-43.51,29.53c-8.49,18.14-4.35,30.33-0.91,36.18c18.37-1.34,35.75-8.36,51.76-20.92l0.37-0.3 c14.1-11.73,36.66-35.46,29.34-62.61c-4.09-15.15-16.68-25.9-33.69-28.76c-21.6-3.62-53.78,5.66-78.89,42.85 c-15.21,20.26-39.22,90.36,28.07,123.96c60.5,26.44,114.59-25.81,114.59-25.81L242.96,166.16z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.11,114.18c-9.22-6.72-22.23-19.11-27.66-24.69l-23.81,27.07c12.76,16.15,36,31.18,44.14,35.6 C96.66,138.21,99.89,124.86,104.11,114.18z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Clear_Space_-_Non-Printatble"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "16.81,124.59 25.23,117.84 20.07,111.67 11.64,118.41  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.5,109.71c0,0-7.66-8.24-7.66-16.7c0-10,7.12-12.83,8.54-13.32c8.38-2.88,18.23,4.72,20.91,9.77 c1.09,2.06,2.19,4.97,1.02,7.18c-0.04,0.07-0.56,0.95-3.04-0.43c-1.59-0.88-7.63-5.38-8.86-13.05c-5.44-2.55-9.1-1.3-10.85-0.27 c0.4,5.51,2.51,10.73,6.28,15.53l0.09,0.11c3.52,4.23,10.64,11,18.78,8.8c4.54-1.23,7.77-5,8.63-10.11 c1.08-6.48-1.7-16.14-12.86-23.67C33.4,69,12.38,61.79,2.3,81.98c-7.93,18.15,7.74,34.38,7.74,34.38L18.5,109.71z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.09,68.06c2.01-2.77,5.73-6.67,7.41-8.3l-8.12-7.14c-4.85,3.83-9.35,10.8-10.68,13.24 C26.89,65.82,30.89,66.79,34.09,68.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "124.69,35.86 117.95,27.44 111.78,32.6 118.52,41.02  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.82,34.17c0,0-8.24,7.66-16.7,7.66c-10,0-12.83-7.12-13.32-8.54c-2.88-8.38,4.72-18.23,9.77-20.91 c2.06-1.09,4.97-2.19,7.18-1.02c0.07,0.04,0.95,0.56-0.43,3.04c-0.88,1.59-5.38,7.63-13.05,8.86c-2.55,5.44-1.3,9.1-0.27,10.85 c5.51-0.4,10.73-2.51,15.53-6.28l0.11-0.09c4.23-3.52,11-10.64,8.8-18.78c-1.23-4.54-5-7.77-10.11-8.63 c-6.48-1.08-16.14,1.7-23.67,12.86c-4.56,6.08-11.77,27.11,8.42,37.19c18.15,7.93,34.38-7.74,34.38-7.74L109.82,34.17z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.16,18.58c-2.77-2.01-6.67-5.73-8.3-7.41l-7.14,8.12c3.83,4.85,10.8,9.35,13.24,10.68 C65.93,25.78,66.9,21.78,68.16,18.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "733.13,227.62 741.56,220.88 736.39,214.71 727.97,221.45  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M734.83,212.75c0,0-7.66-8.24-7.66-16.7c0-10,7.12-12.83,8.54-13.32c8.38-2.88,18.23,4.72,20.91,9.77 c1.09,2.06,2.19,4.97,1.02,7.18c-0.04,0.07-0.56,0.95-3.04-0.43c-1.59-0.88-7.63-5.38-8.86-13.05c-5.44-2.55-9.1-1.3-10.85-0.27 c0.4,5.51,2.51,10.73,6.28,15.53l0.09,0.11c3.52,4.23,10.64,11,18.78,8.8c4.54-1.23,7.77-5,8.63-10.11 c1.08-6.48-1.7-16.14-12.86-23.67c-6.08-4.56-27.11-11.77-37.19,8.42c-7.93,18.15,7.74,34.38,7.74,34.38L734.83,212.75z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M750.42,171.09c2.01-2.77,5.73-6.67,7.41-8.3l-8.12-7.14c-4.85,3.83-9.35,10.8-10.68,13.24 C743.21,168.86,747.22,169.83,750.42,171.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "716.34,263.42 709.6,254.99 703.43,260.16 710.17,268.58  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M701.47,261.73c0,0-8.24,7.66-16.7,7.66c-10,0-12.83-7.12-13.32-8.54c-2.88-8.38,4.72-18.23,9.77-20.91 c2.06-1.09,4.97-2.19,7.18-1.02c0.07,0.04,0.95,0.56-0.43,3.04c-0.88,1.59-5.38,7.63-13.05,8.86c-2.55,5.44-1.3,9.1-0.27,10.85 c5.51-0.4,10.73-2.51,15.53-6.28l0.11-0.09c4.23-3.52,11-10.64,8.8-18.78c-1.23-4.54-5-7.77-10.11-8.63 c-6.48-1.08-16.14,1.7-23.67,12.86c-4.56,6.08-11.77,27.11,8.42,37.19c18.15,7.93,34.38-7.74,34.38-7.74L701.47,261.73z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M659.81,246.13c-2.77-2.01-6.67-5.73-8.3-7.41l-7.14,8.12c3.83,4.85,10.8,9.35,13.24,10.68 C657.58,253.34,658.55,249.34,659.81,246.13z"
  }))), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 52.64,
    y1: 280.2,
    x2: 52.64,
    y2: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0.72,
    y1: 52.64,
    x2: 768.72,
    y2: 52.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0.72,
    y1: 227.64,
    x2: 768.72,
    y2: 227.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 716.38,
    y1: 280.2,
    x2: 716.38,
    y2: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.04,
    className: "st2",
    width: 768.88,
    height: 280.28
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHkexpress);
export default __webpack_public_path__ + "static/media/hkexpress.2262784d7f72f3691eb88e7d14df1d74.svg";
export { ForwardRef as ReactComponent };